import { Col, List, Row, Tag } from "antd";
import { useTranslation } from "react-i18next";
import UserModalRangePicker from "../UserModalRangePicker";

interface GeneralInfoTabContentProps {
    fetchUserDetailsData: any;
    handleRangePickerChange: any
    dateRange: any
}

const GeneralInfoTabContent: React.FC<GeneralInfoTabContentProps> = ({
    fetchUserDetailsData,
    handleRangePickerChange,
    dateRange
}) => {
    const { t } = useTranslation("users");
    const data = [
        {
            title: t("userDetails.selectDateRange"),
            content: <UserModalRangePicker userId={fetchUserDetailsData[0]?.id} handleRangePickerChange={handleRangePickerChange} dateRange={dateRange} />,
        },
        {
            title: t("userDetails.specialties"),
            content: fetchUserDetailsData[0]?.speciality.map((item: any) => (
                <Tag key={item.id} className="generalinfo-tab-content">
                    {item?.name}
                </Tag>
            )),
        },
        {
            title: t("userDetails.groups"),
            content: (
                <div>
                    {fetchUserDetailsData[0]?.department.map((item: any) => (
                        <Tag key={item.id} className="generalinfo-tab-content">
                            {item?.name}
                        </Tag>
                    ))}
                </div>
            ),
        },
        {
            title: t("userDetails.activeSites"),
            content: (
                <div>
                    {fetchUserDetailsData[0]?.hospital.map((item: any) => (
                        <Tag key={item.id}>{item?.name}</Tag>
                    ))}
                </div>
            ),
        },
        {
            title: t("userDetails.numberOfChanges"),
            content: fetchUserDetailsData[0]?.change_count,
        },
        {
            title: t("userDetails.acceptedRequests"),
            content: fetchUserDetailsData[0]?.accept_count,
        },
        {
            title: t("userDetails.numberOfShifts"),
            content: fetchUserDetailsData[0]?.shift_count,
        },
        { title: t("userDetails.leavesCount"), content: fetchUserDetailsData[0]?.holiday_count },
        {
            title: t("userDetails.numberOfHours"),
            content: fetchUserDetailsData[0]?.total_hours,
        },
    ];

    return (
        <List
            dataSource={data}
            className="user-card-section"
            renderItem={(item) => (
                <List.Item style={{ padding: "8px",overflowX:"hidden" }}>
                    <Row gutter={[16, 8]} align="middle">
                        <Col flex="none">
                            <h4 style={{ margin: 0 }} className="generalinfo-tab-content">
                                {item.title}
                            </h4>
                        </Col>
                        <Col flex="auto">
                            <p style={{ margin: 0 }} className="generalinfo-tab-content">
                                {item.content}
                            </p>
                        </Col>
                    </Row>
                </List.Item>
            )}
        />
    );
};


export default GeneralInfoTabContent